import styled, { css } from 'styled-components';

import { CONTAINER_PADDING, CONTAINER_WIDTH } from '@components/blocks/blocks.constants';
import { media } from '@theme/media';
import { COLORS } from '@theme/colors';
import { FONT_SIZE, LETTER_SPACING, typography } from '@theme/font';
import { blurredTransparentHeaderBackgroundStyles } from '@components/header/header.styles';
import { OFFSET } from '@theme/helpers';
import { colonSuffix, containerStyles, paragraphTextStyles } from '@components/blocks/blocks.styles';

export const Container = styled.div`
  padding-top: ${OFFSET.L};
  padding-bottom: ${OFFSET.M};

  ${media.desktop} {
    margin: ${OFFSET.XS} auto;
    max-width: none;
  }
`;

export const ContainerInnerWeb = styled.div`
  padding-bottom: 0px;
  margin-left: -20px;
`;

export const ContainerInnerMobile = styled.div`
  padding-bottom: ${CONTAINER_PADDING * 1}px;
`;

export const ContainerNarrow = styled.div`
  max-width: 710px;
  margin: 0 ${OFFSET.S};

  ${media.tablet} {
    margin: 0 auto;
  }
`;

export const ProductsContainer = styled.div`
  margin: 5px 5px 5px;

  ${media.tablet} {
    margin: ${OFFSET.S} 0 0;
  }
`;

export const ArtistsLinksContainer = styled.div`
  margin: ${OFFSET.M};

  ${media.tablet} {
    display: flex;
    gap: ${OFFSET.M};
  }
`;

export const ArtistLinkContent = styled.span`
  padding-bottom: 1px;
  border-bottom: 1px solid transparent;
  text-align: center;
`;

export const ArtistLink = styled.a`
  ${typography({ size: FONT_SIZE.L })};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0;
  padding: 54px 0 1px;
  line-height: 1;
  text-transform: uppercase;

  &:first-of-type {
    border-top: 1px solid black;
  }

  &:hover ${ArtistLinkContent}:last-of-type {
    border-color: black;
  }

  ${media.tablet} {
    ${typography({ size: FONT_SIZE.L })};
    border-top: 1px solid black;
  }
`;

export const MenuContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 13px;
  height: 44px;
  border-top: 1px solid ${COLORS.BLACK10};
  ${blurredTransparentHeaderBackgroundStyles}

  ${media.tablet} {
    height: 51px;
  }
`;

const menuButtonStyles = css`
  ${typography({ spacing: LETTER_SPACING.M })};
  padding: 9px ${OFFSET.XS};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.tablet} {
    padding: 9px 20px;
  }
`;

export const MenuOption = styled.div`
  ${menuButtonStyles};
`;

export const HorizontalLine = styled.div`
  border-bottom: 1px solid #000;
  margin: 0 20px 0;

  ${media.tablet} {
    margin: ${OFFSET.M} 32px 0;
  }
`;

export const linkStyles = css`
  text-decoration: none;
  ${typography({ size: FONT_SIZE.ML, spacing: LETTER_SPACING.M })};
  display: block;

  ${media.tablet} {
    ${typography({ size: FONT_SIZE.MLL, spacing: LETTER_SPACING.M })};
  }
`;

export const ArtistTitle = styled.a`
  ${linkStyles}
`;

export const ArtistContainer = styled.div`
  margin: ${OFFSET.XS} auto;

  ${media.desktop} {
    margin: ${OFFSET.M} auto;
    padding: 0;
    max-width: none;
    display: grid;
    grid-template-columns: calc(50% - ${CONTAINER_WIDTH / 2}px) ${CONTAINER_WIDTH}px auto;
  }
`;

export const Title = styled.h3`
  max-width: ${CONTAINER_WIDTH}px;
  width: 100%;
  margin: 20px auto;
  padding: 0 20px;

  ${paragraphTextStyles};

  ${media.desktop} {
    margin: 40px 0 0 15px;
  }
`;

export const ContentBodyWrapper = styled.div`
  margin-left: -15px !important;

  ${media.desktop} {
    margin-top: -24px;
  }
`;
